import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faStar as faStarEmpty } from "@fortawesome/free-regular-svg-icons";
import { faStar as faStarSolid } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import TextCopyIcon from '../utils/text-copy-icon.js';

class CurrencyCardView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;
		
		this.uuid = this.app.guid();

		this.card = null;
		this.currency = null;

		this.currencycards = [];
		
		this.closing = false;

		this.state = {
			creditbalance: 'loading...',
			position: null,
			position_int: -1,
			position_string: 'loading...',
			address_string: 'loading...',
			privatekey_string: 'loading...',
			web3providerurl_string: 'loading...',
			message_text: 'loading...',
			to_address: '',
			transfer_amount: 0,
			need_credit_units: false,
			credit_units_requested: 0,
			priceinfo: '',
			sourcecard: null,
			processinginfo: 'processing transfer',
			processing: false
		};
	}


	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	async _readCurrencyCards() {
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let currency = this.currency;

		if (!currency)
			return Promise.reject('currency is not defined');

		var cards = [];

		let _currencycards = await mvcmyquote.getCurrencyCardList(rootsessionuuid, walletuuid, currency.uuid);

		// enrich items
		for (var j = 0; j < _currencycards.length; j++) {
	
			_currencycards[j].currency = currency;
			_currencycards[j].currencyuuid = currency.uuid;

			var _privkey = await mvcmyquote.getCardPrivateKey(rootsessionuuid, walletuuid, _currencycards[j].uuid).catch(err => {});
			_currencycards[j].cansign = (_privkey ? true : false);

			let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, _currencycards[j].uuid);
		
			if (pos !== undefined) {
				_currencycards[j].balance_int = await pos.toInteger();
				_currencycards[j].balance_string = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currency.uuid, pos);
			}

			let credits = await mvcmyquote.getCreditBalance(rootsessionuuid, walletuuid, _currencycards[j].uuid);
			
			_currencycards[j].credits = credits;
		}

		cards = _currencycards;

		return cards;		
	}
	
	async _filterCreditPositiveCards() {
		let items = [];
		let cards = this.currencycards;

		for (var i = 0; i < cards.length; i++) {
			if (cards[i].cansign !== true)
				continue;

			let credit_balance = (cards[i].credits ? cards[i].credits.transactionunits : 0);
			let credit_threshold = (cards[i].credits ?  cards[i].credits.threshold : 0);

			if (credit_balance > credit_threshold) {
				items.push(cards[i]);
			}
		}

		return items;
	}

	
	// post render commit phase
	_getCreditsUnitsRequested(credit_units_requested) {
		return parseInt((credit_units_requested > 0 ? credit_units_requested : 10));
	}

	_getCreditsUnitsToBuy(credit_units_requested) {
		return this._getCreditsUnitsRequested(credit_units_requested) + 3;
	}

	async _getPriceInfo(price_struct) {
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;

		let currency = this.currency;
		let currencyuuid = currency.uuid;

		let currencyamount = price_struct.currency_amount
		let currencyamount_string = await currencyamount.toDecoratedString();

		let priceinfo = price_struct.credit_units_requested + ' ' + mvcmyquote.t('transaction units will cost you approximately') + ' ' + currencyamount_string;
		
		return priceinfo;
	}

	componentDidUpdate(prevProps, prevState) {
		console.log('CurrencyCardView.componentDidUpdate called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		// entered a new credit units
		if (this.state.credit_units_requested != prevState.credit_units_requested) {
			// check it's a proper positive integer
			let proper_int_string = String(Math.floor(Number(this.state.credit_units_requested)));
			
			if (proper_int_string != String(this.state.credit_units_requested)) {
				this._setState({credit_units_requested: proper_int_string});
			}

			// update price info
			let currency = this.currency;
			let currencyuuid = currency.uuid;
			let credit_units_requested = this.state.credit_units_requested;
			let priceinfo = '';;

			if (currency && currency.ops && (currency.ops.cantopup !== true) && (currency.ops.canswap === true)) {
				// check price to buy requested amount of credit units
				mvcmyquote.getPriceForCreditUnits(rootsessionuuid, currencyuuid, this._getCreditsUnitsToBuy(credit_units_requested))
				.then(price_struct => {
					price_struct.credit_units_requested = this._getCreditsUnitsRequested(credit_units_requested);

					return this._getPriceInfo(price_struct);

				})
				.then(priceinfo => {
					this._setState({priceinfo});
				})
				.catch(err => {
					console.log('error in CurrencyCardView.componentDidUpdate: ' + err);
				})
			}


		}

		// entered a new token amount
		if (this.state.transfer_amount != prevState.transfer_amount) {
			// check it's a proper decimal
			let currencyuuid = (this.currency ? this.currency.uuid : null);

			if (currencyuuid) {
/* 				let properdecimalamount;
				let proper_decimal_string;

				mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, this.state.transfer_amount)
				.then(currencyamount => {
					return currencyamount.getDecimalAmount();
				})
				.then(decimalamount => {
					properdecimalamount = decimalamount;
					return decimalamount.toFixedString();
				})
				.then(decimalamountstring => {
					proper_decimal_string = decimalamountstring;
					return mvcmyquote.getDecimalAmount(rootsessionuuid, this.state.transfer_amount);
				})
				.then(decimalamount => {
					return properdecimalamount.equals(decimalamount);
				})
				.then(areequals => {
					if (areequals !== true) {
						this._setState({transfer_amount: proper_decimal_string});
					}
				})
				.catch(err => {
					console.log('error in CurrencyCardView.componentDidUpdate: ' + err);
				}); */
			}
		}

	}

	componentDidMount() {
		console.log('CurrencyCardView.componentDidMount called');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
				
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		this.checkNavigationState().catch(err => {console.log('error in CurrencyCardView.checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		try {
			// check navigation
			let app_nav_state = this.app.getNavigationState();
			let app_nav_target = app_nav_state.target;

			// check wallet is unlocked
			let unlocked = await this.app.checkWalletUnlocked()
			.catch(err => {
			});
	
			if (!unlocked) {
				// we open the default device wallet
				let devicewallet = await this.app.openDeviceWallet()
				.catch(err => {
				});
	
				walletuuid = devicewallet.uuid;
	
				this._setState({isdevicewallet: true});
	
			}
			else {
				let isdevicewallet = await this.app.isDeviceWallet(walletuuid);
	
				this._setState({isdevicewallet});
			}
	
		

			if (app_nav_target && (app_nav_target.route == 'currencycard') && (app_nav_target.reached == false)) {
				var params = app_nav_target.params;

				if (!params) {
					this.app.gotoRoute('home');
					return;
				}

				let currencyuuid = params.currencyuuid;
				let cardaddress = params.cardaddress;

				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid);

				if (!currency) {
					this.app.gotoRoute('home');
					return;
				}

				let wallet = await mvcmodule.getWalletInfo(rootsessionuuid, walletuuid);
			
				let card;
				
				if (cardaddress)
					card = await mvcmyquote.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, currencyuuid, cardaddress);
				else
					card = await mvcmyquote.getCurrencyCard(rootsessionuuid, walletuuid, currencyuuid);


				this.card = card;
				this.currency = currency;

				// mark target as reached
				app_nav_target.reached = true;
			}
			else {
				this.app.gotoRoute('home');
				return;
			}

			// fill info for current card
			if ((this.card) && (this.currency)) {
				let card = this.card;
				let currency = this.currency;

				let carduuid = card.uuid;
				let currencyuuid = currency.uuid;

				let scheme = await mvcmodule.getSchemeInfo(rootsessionuuid, card.schemeuuid );

				const credits = await mvcmyquote.getCreditBalance(rootsessionuuid, walletuuid, carduuid);
				const creditbalance = credits.transactionunits;
				credits.threshold = await mvcmodule.getSchemeTransactionUnitsThreshold(rootsessionuuid, scheme.uuid);

				const position = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid, carduuid);
				const position_string = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, position);
				const position_int = await position.toInteger();
		
				
				// message translated in user's language
				let message_text = '';
				
				// export
				let address = card.address;
				let privatekey = await mvcmodule.getCardPrivateKey(rootsessionuuid, walletuuid, carduuid).catch(err => {});
				let web3providerurl = scheme.network.ethnodeserver.web3_provider_url;

				let address_string = (address ? mvcmodule.fitString(address, 32) : '');
				let privatekey_string = (privatekey ? mvcmodule.fitString(privatekey, 32) : '');
				let web3providerurl_string = (web3providerurl ? mvcmodule.fitString(web3providerurl, 48) : '');

				if (privatekey) {
					message_text = mvcmyquote.t(
						'If you generated this card instead of importing it thanks to an external private key \
						it is strongly recommended to copy the private key thanks to the icon next to the \
						corresponding box and save it in a safe  place to be able to re-create the card. If you \
						don\'t, you might loose all the funds that are allocated to this card.');
				}
				else {
					message_text = mvcmyquote.t(
						'This card has been imported through its address and no private key is currently stored.\
						Accordingly, this card is read-only and you can not do any transaction through the interface.');
				}

				let need_credit_units = this.state.need_credit_units;
				let credit_units_requested = this.state.credit_units_requested;
				
				if (credits.transactionunits < credits.threshold) {
					need_credit_units = true;
					credit_units_requested = (credits.threshold - credits.transactionunits) + 1;
				}

				// buying
				let priceinfo = '';

				if (need_credit_units) {
					// fill other cards on same currency
					this.currencycards = await this._readCurrencyCards();
					this.positivecards = await this._filterCreditPositiveCards();
				}
				else {
					if ((currency.ops.cantopup !== true) && (currency.ops.canswap === true)) {
						// check price to buy credit units
						let price_struct = await mvcmyquote.getPriceForCreditUnits(rootsessionuuid, currencyuuid, this._getCreditsUnitsToBuy(credit_units_requested));
						
						price_struct.credit_units_requested = this._getCreditsUnitsRequested(credit_units_requested);

						
						priceinfo = await this._getPriceInfo(price_struct);
					}
				}

				this._setState({message_text, currency,
					currentcard: card, 
					creditbalance, position, position_int, position_string,  
					address, privatekey, web3providerurl,
					address_string, privatekey_string, web3providerurl_string,
					need_credit_units, credit_units_requested, priceinfo});


			}

		}
		catch(e) {
			console.log('exception in CurrencyCardView.checkNavigationState: '+ e);
		}
		

	}

	async onRefreshPage() {
		console.log('CurrencyCardView.onRefreshPage called');

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async onMainCardSwitch() {
		console.log('CurrencyCardView.onMainCardSwitch called');
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		// set current card as main card for its currency
		let { currency, currentcard } = this.state;

		await mvcmyquote.setCurrencyCard(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid)
		
		let maincardswitchedat = Date.now();

		this._setState({maincardswitchedat});
	}
	
	// end of life
	componentWillUnmount() {
		this.closing = true;

		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
		
		this.app.closeDeviceWallet();
	}
	
	// user actions
	async onTransfer() {
		console.log('onTransfer pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let {currentcard, currency, transfer_amount, to_address} = this.state;

		this.setState({processing: true});

		try {
			let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currency.uuid, transfer_amount);
			let tokenamount_int = await tokenamount.toInteger();
	
	
			// perform payment
			let txhash_payment = await mvcmyquote.payAmount(rootsessionuuid, walletuuid, currentcard.uuid, to_address, currency.uuid, tokenamount_int)
			.catch(err => {
				console.log('error in CurrencyCardView.onTransfer: ' + err);
			});
	
			if (!txhash_payment) {
				this.app.alert('Could not transfer amount');
				this.setState({processing: false});
				return;
			}
				
			
			this.setState({processing: false});

			this.app.refreshPage();	
		
			return true;
		}
		catch(e) {
			console.log('exception in onTransfer: ' + e);
			this.setState({processing: false});
		}
	}

	// buying
	async onBuyCredits() {
		console.log('onBuyCredits pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let {currentcard, currency, credit_units_requested} = this.state;

		this.setState({processing: true});

		try {
			let credit_units_tobuy = this._getCreditsUnitsToBuy(credit_units_requested);

			var txhash = await mvcmyquote.buyCreditUnits(rootsessionuuid, walletuuid, currentcard.uuid, currency.uuid, credit_units_tobuy)
			.catch(err => {
				console.log('error in CurrencyCardView.onBuyCredits: ' + err);
			});
	
			if (!txhash) {
				this.app.alert('Could not buy credit units');
				this.setState({processing: false});
				return;
			}

			this.setState({processing: false});

			this.app.refreshPage();	
		
			return true;
		}
		catch(e) {
			console.log('exception in onBuyCredits: ' + e);
			this.setState({processing: false});
		}
	
	}

	// picking from
	async onSelectSourceCard(uuid) {
		var cards = this.currencycards;
		let sourcecard;

		for (var i = 0; i < cards.length; i++) {
			if (uuid === cards[i].uuid) {
				sourcecard = cards[i];
				break;
			}
		}

		if (sourcecard) {
			this._setState({sourcecard});
		}

		return true;
	}

	async onPickCreditsFrom() {
		console.log('onPickCreditsFrom pressed!');
		
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;
		
		let { sourcecard, currentcard, credit_units_requested  } = this.state;

		this.setState({processing: true});

		try {
			let units_txhash = await mvcmyquote.transferTransactionUnits(rootsessionuuid, walletuuid, sourcecard.uuid, currentcard.uuid, credit_units_requested);

			if (!units_txhash) {
				this.app.alert('Could not pick transaction units from source card');
				this.setState({processing: false});
				return;
			}

			this.setState({processing: false});

			this.app.refreshPage();	
	
			return true;
		}
		catch(e) {
			console.log('exception in onPickCreditsFrom: ' + e);
			this.app.error('exception in onPickCreditsFrom: ' + e);

			this.app.alert('could not pick transaction units')

			this.setState({processing: false});
		}
	}

	
	// rendering
	renderBuyMoreCreditsPart() {
		let { currency, credit_units_requested, position_int,priceinfo } = this.state;

		if (currency.ops.canswap  !== true)
		return (<></>);

		let credit_units_requested_disabled = ((credit_units_requested > 0) || (parseInt(credit_units_requested) > 0) ? false : true);

		if (position_int == 0)
			credit_units_requested_disabled = true;

		return (
			<div>
			<div className="Separator">&nbsp;</div>
			<FormGroup controlId="buycredits">
				<FormLabel>Add credit units</FormLabel>
				{(priceinfo && priceinfo.length ? <div className="TextBox">{priceinfo}</div> : <></>)}
				<FormGroup className="ClaimerCardLine">
					<FormControl
						autoFocus
						type="text"
						value={credit_units_requested}
						onChange={e => this.setState({credit_units_requested: e.target.value})}
					/>
					<Button 
					disabled={credit_units_requested_disabled}
					onClick={this.onBuyCredits.bind(this)} 
					type="submit">
					Buy
					</Button>

				</FormGroup>
			</FormGroup>
			</div>
		);
		
	}

	renderPickCreditsFromPart() {
		let mvcmodule = this.getMvcModuleObject();

		let { sourcecard, credit_units_requested } = this.state;
		let positivecards = this.positivecards;

		let can_pick_credit_units = false;
		let pick_credit_units_disabled = true;

		if ((!positivecards) || (positivecards.length == 0)) {
			can_pick_credit_units = true;
		}

		if (sourcecard) {
			if ((credit_units_requested > 0) || (parseInt(credit_units_requested) > 0)) {

				if (credit_units_requested < sourcecard.credits.transactionunits) {
					pick_credit_units_disabled = false;
				}
				else {
					pick_credit_units_disabled = true;
				}
			}
			else {
				pick_credit_units_disabled = true;
			}

		}
		else {
			pick_credit_units_disabled = true;
		}

		return (
				<div>
				<div className="Separator">&nbsp;</div>

				{(can_pick_credit_units ? 
				<div className="TextBox">There is no other card for this currency that has enough transaction credits to pick some units from it.</div> :
				<FormGroup controlId="pickcredits">
					<FormLabel>Pick from</FormLabel>
					<FormGroup controlId="newcard" className="AddCardLine">
						<FormControl className="CardPrivateKeyInput"
							disabled
							autoFocus
							type="text"
							value={(sourcecard ? sourcecard.address : '')}
							onChange={e => this._setState({signingkey: e.target.value})}
						/>
						<DropdownButton
							id="input-dropdown-addon"
							title="Cur."
							onSelect={e => this.onSelectSourceCard(e)}
						>
							{positivecards.map((item, index) => (
								<Dropdown.Item key={item.uuid} eventKey={item.uuid} value={item.uuid}>{'card with ' + item.credits.transactionunits + ' units - ' + mvcmodule.fitString(item.address, 12)}</Dropdown.Item>
							))}
						</DropdownButton>
					</FormGroup>
				</FormGroup>
				)}

				<FormGroup controlId="pickcredits">
					<FormLabel># credit units</FormLabel>
					<FormGroup className="ClaimerCardLine">
						<FormControl
							autoFocus
							type="text"
							value={credit_units_requested}
							onChange={e => this.setState({credit_units_requested: e.target.value})}
						/>
						<Button 
						disabled={pick_credit_units_disabled}
						onClick={this.onPickCreditsFrom.bind(this)} 
						type="submit">
						Pick
						</Button>
	
					</FormGroup>
				</FormGroup>
				</div>
			);
	

	}

	renderTransferToPart() {
		let { to_address, transfer_amount } = this.state;

		let transfer_disabled = (to_address.length && ((transfer_amount > 0) || (parseInt(transfer_amount) > 0) ) ? false : true);

		return (
			<div>
			<div className="Separator">&nbsp;</div>
			<FormGroup controlId="transferto">
				<FormLabel>Transfer to address</FormLabel>
				<FormGroup className="ClaimerCardLine">
					<FormControl
						autoFocus
						type="text"
						value={(to_address ? to_address : '')}
						onChange={e => this.setState({to_address: e.target.value})}
					/>
				</FormGroup>
			</FormGroup>
			<FormGroup controlId="transfer">
				<FormLabel>Amount</FormLabel>
				<FormGroup className="ClaimerCardLine">
					<FormControl
						autoFocus
						type="text"
						value={transfer_amount}
						onChange={e => this.setState({transfer_amount: e.target.value})}
					/>
					<Button 
					disabled={transfer_disabled}
					onClick={this.onTransfer.bind(this)} 
					type="submit">
					Transfer
					</Button>

				</FormGroup>
			</FormGroup>
			</div>		
		);
	}

	renderTransactionPart() {
		let { currency, need_credit_units } = this.state;

		if (currency.ops.canpay !== true)
			return (<></>);

		if (need_credit_units) {
			return (
				<div>
					{this.renderPickCreditsFromPart()}
				</div>
			);
		}
		else {

			return (
				<div>
					{this.renderTransferToPart()}
					{this.renderBuyMoreCreditsPart()}
				</div>
			);
		}

	}

	renderCurrencyCardView() {
		let { currency, currentcard,
			creditbalance, position_string,
			privatekey, address, web3providerurl,
			privatekey_string, address_string, web3providerurl_string } = this.state;
			
		let maincard = (currentcard && currentcard.xtra_data.myquote ? currentcard.xtra_data.myquote.maincard : false);

		
		return (
			<div className="Form">
				<FormGroup className="CurrencyCard" controlId="balance">
				<span>
					<FormLabel>Credit units</FormLabel>
					<FormControl
						className="CurrencyCardBalance"
						disabled
						autoFocus
						type="text"
						value={creditbalance}
					/>
				</span>
				<span>
					<FormLabel>Balance</FormLabel>
					<FormControl
						className="CurrencyCardBalance"
						disabled
						autoFocus
						type="text"
						value={position_string}
					/>
				</span>
				<span>
				{(maincard ? 
				<FontAwesomeIcon icon={faStarSolid} size="2x" /> :
				<FontAwesomeIcon icon={faStarEmpty} size="2x" onClick={this.onMainCardSwitch.bind(this)} />)}
				</span>

				</FormGroup>

				<FormGroup controlId="address">
					<FormLabel>Address</FormLabel>
					<FormGroup className="ClaimerCardLine">
						<FormControl
							className="CurrencyCardAddress"
							disabled
							autoFocus
							type="text"
							value={(address_string ? address_string : '')}
						/>
						<div className="ShareIcon">
							<TextCopyIcon
								app={this.app}
								text={address}
								message="address has been copied to clipboard"
							/>
						</div>
					</FormGroup>
				</FormGroup>

				{(privatekey ? 
				<FormGroup controlId="privatekey">
					<FormLabel>Private key</FormLabel>
					<FormGroup className="ClaimerCardLine">
						<FormControl
							className="CurrencyCardAddress"
							disabled
							autoFocus
							type="text"
							value={(privatekey_string ? privatekey_string : '')}
						/>
						<div className="ShareIcon">
							<TextCopyIcon
								app={this.app}
								text={privatekey}
								message="private key has been copied to clipboard"
							/>
						</div>
					</FormGroup>
				</FormGroup> :
				<></>
				)}

				<FormGroup controlId="web3providerurl">
					<FormLabel>RPC URL {(currency && currency.name ? 'for ' + currency.name : '')}</FormLabel>
					<FormGroup className="ClaimerCardLine">
						<FormControl
							className="CurrencyCardAddress"
							disabled
							autoFocus
							type="text"
							value={(web3providerurl_string ? web3providerurl_string : '')}
						/>
						<div className="ShareIcon">
							<TextCopyIcon
								app={this.app}
								text={web3providerurl}
								message="rpc url has been copied to clipboard"
							/>
						</div>
					</FormGroup>
				</FormGroup>

			</div>
		  );
	}

	render() {
		let {processing} = this.state; 

		if (processing === true) {
			return (
				<div className="Splash">
					<div>{this.state.processinginfo}</div>
					<Dots />
				</div>
			);
		}

		let { message_text, privatekey } = this.state;

		return (
			<div className="Container">
				<div className="Title">Currency Card</div>
				{ this.renderCurrencyCardView()}
				
				<div className="TextBox">
				  {message_text}
			  	</div>

				{(privatekey ? 
				 this.renderTransactionPart():
				 <></>)}

			</div>
		  );
	}
	
}


// propTypes validation
CurrencyCardView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {CurrencyCardView};
export default connect(mapStateToProps, mapDispatchToProps)(CurrencyCardView);

